import type { SettingDefinition, SettingsSource } from '../models/settings-hub.model';

import { action, field } from './settings-builders';
import { PRICE_LISTS_COUNT, priceListOptions } from './settings-options';

const priceListSettings: SettingDefinition[] = Array.from({ length: PRICE_LISTS_COUNT }, (_, index) => index + 1).flatMap(priceList => [
    {
        id: `price_list_${priceList}_name`,
        preferenceKey: `price_list_${priceList}_name`,
        control: 'text',
        label: 'SETTINGS.SETTINGS.NAME_PRICE_LIST',
        labelParams: { value: priceList },
        maxLength: 30
    },
    {
        id: `price_list_${priceList}_hide`,
        preferenceKey: `price_list_${priceList}_hide`,
        control: 'toggle',
        label: 'SETTINGS.SETTINGS.HIDE_PRICE_LIST',
        labelParams: { value: priceList }
    }
]);

const priceListNameKeys = Array.from({ length: PRICE_LISTS_COUNT }, (_, index) => `price_list_${index + 1}_name` as const);

export const STOCK_SUBCATEGORY: SettingsSource = {
    id: 'stock-price-lists',
    cards: [
        {
            id: 'product-options',
            settings: [
                field.toggle('items.enable_alternative_translate', 'SETTINGS.SETTINGS.ENABLE_ALTERNATIVE_TRANSLATE'),
                ...[1, 2, 3, 4].map((option): SettingDefinition => ({
                    id: `items.option${option}_name`,
                    preferenceKey: `items.option${option}_name` as 'items.option1_name',
                    control: 'text',
                    label: 'SETTINGS.SETTINGS.OPTION_NAME',
                    labelParams: { value: option }
                })),
                action('refresh-items-cache', 'SETTINGS.SETTINGS.RESET_CACHE', { icon: 'refresh' })
            ]
        },
        {
            id: 'price-lists',
            settings: [
                ...priceListSettings,
                ...([
                    ['orders.normal_pricelist', 'SETTINGS.SETTINGS.ORDERS_NORMAL_PRICELIST'],
                    ['orders.take_away_pricelist', 'SETTINGS.SETTINGS.ORDERS_TAKE_AWAY_PRICELIST'],
                    ['orders.delivery_pricelist', 'SETTINGS.SETTINGS.ORDERS_DELIVERY_PRICELIST']
                ] as const).map(([preferenceKey, label]): SettingDefinition => ({
                    id: preferenceKey,
                    preferenceKey,
                    control: 'select',
                    numeric: true,
                    defaultValue: 0,
                    label,
                    options: priceListOptions,
                    optionsDependOn: priceListNameKeys
                }))
            ]
        },
        {
            id: 'stock-management',
            settings: [
                field.toggle('stock_movements.disable_item_cost_update', 'SETTINGS.SETTINGS.STOCK_DISABLE_ITEM_COST_UPDATE'),
                field.toggle('cashregister.disable_stock_notifications', 'SETTINGS.SETTINGS.CASHREGISTER_DISABLE_STOCK_NOTIFICATIONS'),
                field.toggle('cashregister.show_stock_on_showcase', 'SETTINGS.SETTINGS.SHOW_STOCK_ON_SHOWCASE')
            ]
        }
    ]
};
